module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/gpo-logo.png",
      "height": "45"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('span', {
    staticClass: "d-sm-down-none"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item d-md-down-none"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5eac7c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 563
// module chunks = 1